import { useQuery } from "@tanstack/react-query";

import type { RetailMemberPrices } from "@/utils/algoliaCatalog";
import { getMembershipsDiscountPrices } from "api/methods";

/**
 * Retail member prices (`GET /memberships/discount-prices`), the same answer the retail grid and product page use.
 * Requested only while `enabled` (retail cards are on screen), since it prices every shop package. It does not block
 * the page: retail cards render with their price and member prices fill in when this arrives.
 */
export const useRetailMemberPrices = (enabled: boolean): RetailMemberPrices | undefined =>
  useQuery({ ...getMembershipsDiscountPrices.keyed(), staleTime: 1000 * 60, enabled }).data;
